import { useState, useCallback } from 'react';
import { onboardingService } from '@/features/onboarding/services/onboardingService';
import type { SetupPasswordPayload } from '@/features/onboarding/types/onboarding.types';
import { useSpinner } from '@chikara/ui';
import { t } from '@/i18n';


export const useSetPassword = () => {
    const { show, hide, isSpinnerLoading } = useSpinner();
    const [error, setError] = useState<string | null>(null);

    const setupPassword = useCallback(async (payload: SetupPasswordPayload): Promise<boolean> => {
        show();
        setError(null);
        try {
            await onboardingService.setupPassword(payload);
            return true;
        } catch (err) {
            setError(t('onboarding.setupPassword.error'));
            return false;
        } finally {
            hide();
        }
    }, [show, hide]);

    return {
        setupPassword,
        isLoading: isSpinnerLoading,
        error
    };
};
